import { Link } from 'components/Atoms/Link'
import { TelegramBotButtonCSS } from './TelegramBotButtonCSS.styled'

export const TelegramBotButton = () => {
  return (
    <TelegramBotButtonCSS>
      <Link href='https://t.me/yolorektbot' className='yolobot_header_link' type='button'>
        YOLOBOT
      </Link>
    </TelegramBotButtonCSS>
  )
}
